<div class="modal-header">
  <h4 class="modal-title" i18n>Edit payment card</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.close()"></button>
</div>
<div class="modal-body">
    <div class="row g-3">
      <div class="col-6">
        <label class="form-label" i18n>Card number</label>
        <div>{{ card.number }}</div>
      </div>
      <div class="col-6">
        <label class="form-label" i18n>Expires</label>
        <div>{{ card.expire_month | number: '2.0-0' }}/{{ card.expire_year }}</div>
      </div>
    </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="remove()" i18n>Remove card</button>
  <button type="button" class="btn btn-primary" (click)="makeDefault()" i18n>Make default</button>
</div>